import {ConfiguredElement, ProductElementModifier,} from "../../providers/product/product-types";
import React from "react";
import {ConfiguratorDeleteState} from "./ConfiguratorDeleteState";
import {ConfiguratorModifierState} from "./ConfiguratorModifierState";
import {ConfiguratorValuesState} from "./ConfiguratorValuesState";

interface ConfiguratorSectionProps {
    index: number;
    totalConfigLength: number;
    config: ConfiguredElement;
    selectValues: string[];
    changeConfigType: (index: number, value: string) => void;
    changeConfigValue: (index: number, key: string, value: number | string) => void;
    onRemove: (index: number) => void;
    onModifierAttach: (index: number, modifier: ProductElementModifier) => void;
    onModifierRemove: (index: number, modifierIndex: number) => void;
}

type ConfiguratorState = 'CONFIG' | 'DELETE' | 'MODIFIER';

export const ConfiguratorSection = (props: ConfiguratorSectionProps) => {
    const [state, setState] = React.useState<ConfiguratorState>('CONFIG');

    const possibleModifiers = props.config.config.modifiers
        .filter(m => !props.config.modifiers.some(cm => cm.name === m.name));

    if (state === 'DELETE') {
        return (
            <ConfiguratorDeleteState onConfirm={() => {
                props.onRemove(props.index);
                setState('CONFIG');
            }} onCancel={() => setState('CONFIG')}/>
        )
    }

    if (state === 'MODIFIER') {
        return (
            <ConfiguratorModifierState
                modifiers={possibleModifiers}
                onConfirm={(modifier) => {
                    props.onModifierAttach(props.index, modifier)
                    setState('CONFIG');
                }}
                onCancel={() => setState('CONFIG')}
            />
        )
    }

    return (
        <ConfiguratorValuesState possibleModifiers={possibleModifiers} setState={setState} {...props} />
    );
}